export * from "./intake.routes";
